module.exports = __webpack_public_path__ + "assets/fonts/GothamProNarrow-Bold.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamProNarrow-Bold.woff
// module id = 1910
// module chunks = 0